import Domain from 'helpers/Domain';
import SmartTagCastAPI from '../shared/smart-tag-cast-api';
import { PinHelper } from 'helpers/PinHelper';
import { VideoPagePinTrackingService } from 'services/VideoPagePinTrackingService';
import GeoLocationService from 'services/GeoLocationService';
import DMAStorageService from 'services/DMAStorageService';
import { ErrorCopy } from 'video/errorCopy';
import { ErrorCopyConfig } from 'video/utils/error-copy';
import extraMeta from 'video/shared/extraMeta';
import { getLocale } from 'services/LocalizationService';
import { fetchData } from 'video/shared/smart-tag-adapter/network-tools';
import { handleSmartTagOverlay } from 'video/shared/smart-tag-adapter/smart-tag-overlay-fix';
import { LOW_BIT_2MBPS } from 'helpers/bitrate';
const KIDS = 'Kids';
const ADULT = 'ADULT';
const SHOWTIME_BRAND = 'Showtime';

 //Condition added to avoid local chromcast micro service failure

if (CBS.Registry?.ChromecastLocalEnv !== 'local') {
    const Helper = window.Chromecast?.getHelper();
}
export default class SmartTagAdapter {
    constructor(castSender, smartTagParams, metaData = null, apiMetadata = null) {
        this.smartTagParams = smartTagParams;
        this.playerInstance = null;
        this.smartTagVO = null;
        this.errorCopyConfig = new ErrorCopyConfig(CBS.Registry.brand.name);
        // for internal use, not referenced or reset by SmartTag
        this._contentId = this.smartTagParams._contentID;
        this.video_url = null;
        this.baseUrl = null;
        this.smartTagInstance = null;
        this.smartTagPlayerId = null;
        this.hasAdBlocker = false;
        this.castSender = castSender;
        this.showId = null;
        this.promisesToWaitFor = [];
        this.metaData = metaData || {};
        this.CONTENT = this.smartTagParams.CONTENT || {};
        // getting pinCheck value for pinGatePromise decision logic
        this.pinCheck = this.smartTagParams.pinCheck;
        this.__cpPre = false;
        this.__cpsession = '0';
        this.videoTitle = this.metaData.videoTitle
            ? this.metaData.videoTitle
            : this.smartTagParams._videoTitle
            ? this.smartTagParams._videoTitle
            : '';
        this.contentType = this.smartTagParams.contentType;
        this.fch = this.smartTagParams.fch;
        this.onPlayerStateChanged = null;

        this.AD;
        this.redirectUrl = null;
        this.brandLogoUrl = null;
        this.apiMetadata = apiMetadata ? [apiMetadata] : [this.smartTagParams.apiMetadata];
        this.scheduleAPIData = null;
        //Keep the initial configuration of paramsVO to used in the replay
        this.initialParamsVO = null;
        this.lowbandEnabled = smartTagParams.lowbandEnabled || false;
        this.cpHBTracking = []

        // See if we have to wait for client-side AJAX of drm
        if (window.CBS.Registry.drmPromise) {
            this.addPromiseToWaitFor(
                new Promise((resolve, reject) => {
                    window.CBS.Registry.drmPromise.then(() => {
                        // install the drm object
                        this.CONTENT.drm = window.CBS.Registry.drm;
                        if (window.CBS.Registry.drmType)
                            this.CONTEXT.metaData.drmName =
                                window.CBS.Registry.drmType == 'widevine'
                                    ? 'Widevine'
                                    : 'PlayReady';
                        resolve();
                    });
                })
            );
        }

        this.addPromiseToWaitFor(this.getbrandLogoUrl())

        this.addPromiseToWaitFor(
            new Promise((resolve, reject) => {
                window.cbsoptanon?.onAdsReady((cmp) => {
                    let intervalCount = 0;

                    // Initial call to cmp.gpp.send('ping') does not always return "ready"
                    // Continue calling until 'ready' data is returned or count limit is exceeded
                    const pingInterval = setInterval(() => {
                        cmp?.gpp?.send('ping', (data) => {
                            if (data?.signalStatus === 'ready'){
                                clearInterval(pingInterval);

                                window.CBS.Registry.gpp = {
                                    gppString: data.gppString,
                                    gppSid: (data?.['sectionList'] || []).join('_'),
                                };

                                resolve();
                            }

                            intervalCount += 1;
                            if (intervalCount > 20) {
                                resolve();
                                clearInterval(pingInterval);
                            }
                        });
                    }, 250);
                });
            }),
        );

        // See if we have to wait for client-side AJAX of FreeWheel FMS data
        if (window.CBS.Registry.fmsPromise) {
            this.addPromiseToWaitFor(
                new Promise((resolve, reject) => {
                    window.CBS.Registry.fmsPromise.then(() => {
                        this.AD = this.AD || {};
                        this.AD.FW = this.AD.FW || {};
                        this.AD.FW.FMS = window.CBS.Registry.fms;
                        resolve();
                    });
                })
            );
        }

        //Check if there exists a pending Freewheel GPDR instance
        if (window.CBS.Registry.fwGPDRPromise) {
            this.addPromiseToWaitFor(
                new Promise(resolve => {
                    window.CBS.Registry.fwGPDRPromise.then((GPRDData) => {
                        this.AD = this.AD || {};
                        this.AD.FW = {
                            GDPR: {
                                _fw_gdpr_consent: GPRDData.gdpr_consent,
                                _fw_gdpr: GPRDData.gdpr,
                            },
                            ...this.AD.FW
                        }
                        resolve();
                    });
                })
            );
        }

        this.playerLoadPromise = new Promise((resolve, reject) => {
            this.playerLoadResolver = resolve;
        });

        this.smartTagReadyPromise = new Promise((resolve, reject) => {
            this.smartTagLoadResolver = resolve;
        });

        // using this for startCastSender() when pinGate is enabled
        this.pinGatePromise = new Promise((resolve, reject) => {
            this.pinGateResolver = resolve;
        });

        // resolve pinGatePromise immediately if pinCheck param is false (pinGate is off)
        if (!this.pinCheck) {
            this.pinGateResolver(true);
        }

        this.api = $.extend(castSender || {}, {
            tagCallback: (event) => {
                this.tagCallback(event);
            },
            tagAction: (data) => {
                // get result of tagAction
                let result = this.tagAction(data);
                // if result of tagAction processing is a Promise => return that Promise...
                if (
                    !!result &&
                    (typeof result === 'object' || typeof result === 'function') &&
                    typeof result.then === 'function'
                ) {
                    return result;
                } else {
                    // otherwise
                    // return undefined or any other value we may have in the future...
                    return undefined;
                }
            },
            // this gets called called when smart tag library is ready
            onSmartTagReady: (smartTag) => {
                this.onSmartTagReady(smartTag);
            },
            ContinuousPlayNS: {
                saveContinuousPlaySessionData: (objMediaTrackingMetadata) => {
                    this.saveContinuousPlaySessionData(objMediaTrackingMetadata);
                },
                continuousPlayNextVideoMetadata: () => {
                    this.continuousPlayNextVideoMetadata();
                },
                eraseContinuousPlaySessionData: () => {
                    this.eraseContinuousPlaySessionData();
                }
            },
            CastNS: {
                // defined in smart-tag-cast-api.js
            },
            PINGateNS: {
                onPinAction: (obj) => {
                    this.onPinAction(obj);
                }
            },
            SkinNS: {
                replayResource: (data) => {
                    this.smartTagVO.API.VIDEO.load(paramsVO);
                },
                skinAction: (data) => {
                    switch (data.action) {
                        case 'LiveScheduleAction.GET_LIVE_SCHEDULE':
                            return new Promise((resolve, reject) => {
                                let GeoLocation = new GeoLocationService();
                                /* Creating a new instance of the DMAStorageService class. */
                                return GeoLocation.fetchLocation()
                                    .then((location) => {
                                        // bust browser AJAX cache with timestamp
                                        let DMAStorage = new DMAStorageService();
                                        let extraUrlParam = '&timestamp=' + new Date().getTime();
                                        if (CBS.Registry.user.bundleStatus ?? false) {
                                            extraUrlParam += "&bundleStatus=" + CBS.Registry.user.bundleStatus;
                                        }
                                        let currentLocation = DMAStorage.getCurrentLocation();
                                        let loc = {};
                                        if (currentLocation == null) {
                                            loc = {
                                                lat: location.coords.latitude,
                                                lon: location.coords.longitude
                                            };
                                            DMAStorage.setCurrentLocation(loc);
                                            DMAStorage.removeStorageDMA();
                                        } else {
                                            loc = currentLocation;
                                            if (
                                                loc.lat == location.coords.latitude &&
                                                loc.lon == location.coords.longitude
                                            ) {
                                                let dmaUrlData = DMAStorage.getDMAUrlDataAdapterSchedule();
                                                if (dmaUrlData != '') {
                                                    extraUrlParam += '&dmaInfo=' + dmaUrlData;
                                                }
                                            } else {
                                                loc = {
                                                    lat: location.coords.latitude,
                                                    lon: location.coords.longitude
                                                };
                                                DMAStorage.setCurrentLocation(loc);
                                                DMAStorage.removeStorageDMA();
                                            }
                                        }

                                        let url =
                                            CBS.Registry.region.prefix +
                                            '/live-tv/stream/liveSchedulePlayer/schedule.json?latitude=' +
                                            location.coords.latitude +
                                            '&longitude=' +
                                            location.coords.longitude +
                                            extraUrlParam;
                                        return fetch(url)
                                            .then((response) => {
                                                return response.json();
                                            })
                                            .then((resultData) => {
                                                if (resultData.success) {
                                                    if (DMAStorage.getStorageDMA() == null) {
                                                        if (
                                                            resultData.result.dma !== undefined &&
                                                            resultData.result.dma !== 'undefined'
                                                        ) {
                                                            DMAStorage.setStorageDMA(resultData.result.dma);
                                                        }
                                                    }

                                                    var promises = [];
                                                    let channels = resultData.result.channels;

                                                    channels.forEach((channel, index) => {
                                                        // prune upcoming (for channels data) to 1 entry max
                                                        if (false) {
                                                            if (
                                                                channel.upcomingListing &&
                                                                channel.upcomingListing.length > 1
                                                            ) {
                                                                channel.upcomingListing =
                                                                    channel.upcomingListing.slice(0, 1);
                                                            }
                                                            if (
                                                                channel.currentListing &&
                                                                channel.currentListing.length > 0
                                                            ) {
                                                                channel.upcomingListing = null;
                                                            }
                                                        }
                                                        if (
                                                            CBS.Registry.Features
                                                                .tv_listings_with_channel_api ==
                                                            true
                                                        ) {
                                                            if (
                                                                !channel.currentListing &&
                                                                (!channel.upcomingListing ||
                                                                    channel.upcomingListing
                                                                        .length == 0)
                                                            ) {
                                                                let promise = new Promise(function (
                                                                    resolve,
                                                                    reject
                                                                ) {
                                                                    let url =
                                                                        CBS.Registry.region.prefix +
                                                                        '/live-tv/stream/channelSchedulePlayer/' +
                                                                        channel.slug +
                                                                        '/schedule.json?timestamp=' +
                                                                        new Date().getTime();
                                                                    return fetch(url)
                                                                        .then(function (response) {
                                                                            return response.json();
                                                                        })
                                                                        .then(function (
                                                                            resultData
                                                                        ) {
                                                                            if (
                                                                                resultData.success
                                                                            ) {
                                                                                resultData.result.index =
                                                                                    index;
                                                                                resolve(
                                                                                    resultData.result
                                                                                );
                                                                            } else {
                                                                                resolve({
                                                                                    data: resultData
                                                                                });
                                                                            }
                                                                        });
                                                                });
                                                                promises.push(promise);
                                                            }
                                                        }
                                                    });

                                                    Promise.all(promises).then((listings) => {
                                                        if (
                                                            CBS.Registry.Features
                                                                .tv_listings_with_channel_api ==
                                                            true
                                                        ) {
                                                            listings.forEach((channel) => {
                                                                if (channel.listing.length) {
                                                                    let listing = channel.listing;
                                                                    // remove any currently live listings
                                                                    var i = listing.length;
                                                                    while (i--) {
                                                                        if (
                                                                            listing[i].isListingLive
                                                                        ) {
                                                                            listing.splice(i, 1);
                                                                        }
                                                                    }
                                                                    if (listing.length) {
                                                                        // only return 1 (for channels API use case) though maybe wrong? TODO
                                                                        listing = listing.slice(
                                                                            0,
                                                                            1
                                                                        );
                                                                        channels[
                                                                            channel.index
                                                                        ].upcomingListing = listing;
                                                                    }
                                                                }
                                                            });
                                                        }

                                                        resultData.result.channels = channels;
                                                        this.scheduleAPIData = resultData.result;
                                                        resolve({ data: resultData.result });
                                                    });
                                                } else {
                                                    resolve({ data: resultData });
                                                }
                                            });
                                    })
                                    .catch((error) => {
                                        console.log('Failed to get user location', error);
                                        return '{}';
                                    });
                            });
                            break;
                        case 'LiveScheduleAction.GET_CHANNEL_SCHEDULE':
                            return new Promise(function (resolve, reject) {
                                let storageStationId = localStorage.getItem('stationIdLocation');
                                let url =
                                    CBS.Registry.region.prefix +
                                    '/live-tv/stream/channelSchedulePlayer/' +
                                    data.payload.slug.data +
                                    '/schedule.json?stationId=' +
                                    storageStationId +
                                    '&timestamp=' +
                                    new Date().getTime();
                                return fetch(url)
                                    .then(function (response) {
                                        return response.json();
                                    })
                                    .then(function (resultData) {
                                        if (resultData.success) {
                                            resolve({ data: resultData.result });
                                        } else {
                                            resolve({ data: resultData });
                                        }
                                    });
                            });
                            break;
                        case 'SkinAction.GET_ENDCARD_DATA':
                            //returns continuous play object for shoes, movies and Live-tv

                            const channelObj = data?.payload?.channelObj
                            const contentType = channelObj ? 'live' : data?.payload?.contentType ?? null

                            if (!contentType || !['show', 'movie', 'live', 'clip'].includes(contentType)) {
                                return Promise.reject('ContentType is invalid')
                            }
                            let endCardId
                            let channelSlug = ''
                            switch (contentType) {
                                case 'live':
                                    endCardId = data.payload.listingId ?? ''
                                    channelSlug = data.payload.channelSlug ?? ''
                                    break
                                case 'show':
                                    endCardId = this.showId ?? null
                                    break
                                case 'movie':
                                    endCardId = data?.payload?.contentId ?? this.contentId ?? null
                                    break
                                case 'clip':
                                    endCardId = data?.payload?.contentId ?? this.contentId ?? null
                                    break
                            }

                            if (!endCardId) {
                                return Promise.reject('Invalid endcardId')
                            }

                            return new Promise((resolve, reject) => {
                                const abtest = window.nextShowsAbTest === true ? 1 : 0
                                const mediaType = this.metaData.mediaType ?? '';
                                let position = 0;
                                if (contentType === 'clip') {
                                    const queryString = window.location.search;
                                    const urlParams = new URLSearchParams(queryString);
                                    position = urlParams.get('p');
                                }
                                const url =
                                    contentType === 'live'
                                        ? `${CBS.Registry.region.prefix}/video/endcard/up-next.json?contentType=${contentType}&endCardId=${endCardId}&channelSlug=${channelSlug}`
                                        : `${CBS.Registry.region.prefix}/video/endcard/up-next.json?contentType=${contentType}&endCardId=${endCardId}&contentId=${this._contentId}&mediaType=${mediaType}&var=${abtest}${contentType === 'clip' ? `&showId=${this.showId}&position=${position}`: ''}`;
                                return fetch(url)
                                    .then((response) => {
                                        return response.json()
                                    })
                                    .then((response) => {
                                        resolve(response.result)
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                        reject(error);
                                    });
                            });
                            break;    
                        case 'LiveScheduleAction.GET_CHANNEL_FILTERS':
                            let url =
                                CBS.Registry.region.prefix +
                                '/live-tv/stream/channelCategories.json';
                            if (CBS.Registry.user.bundleStatus ?? false) {
                                url += "?bundleStatus=" + CBS.Registry.user.bundleStatus;
                            }
                            return new Promise((resolve, reject) => {
                                return fetch(url)
                                    .then((response) => {
                                        return response.json();
                                    })
                                    .then((json) => {
                                        resolve({
                                            data: json
                                        });
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                        reject(error);
                                    });
                            });
                            break;

                        case 'LiveScheduleAction.UPDATE_CHANNEL_FILTERS':
                            return new Promise((resolve, reject) => {
                                localStorage.setItem(
                                    'channelBrowseCategory',
                                    data.payload.filters ?? 'all'
                                );
                                resolve();
                            });
                            break;

                        case 'LiveScheduleAction.LIVE_CHANNEL_CLICK':
                            localStorage.setItem('nextGenMenuClicked', true);
                            return new Promise((resolve, reject) => {
                                localStorage.setItem('cbs_nsr', 1);
                                resolve();
                            });
                            break;

                        case 'LiveScheduleAction.CHANGE_CHANNEL':
                            let DMAStorage = new DMAStorageService();
                            let listing = data.payload.listing;
                            let isNotLiveStreaming = listing.contentCANVideo.liveStreamingUrl
                                ? false
                                : true;
                            let slug;
                            if (isNotLiveStreaming) {
                                slug = listing.channelSlug;
                            } else {
                                let urlAx =
                                    listing.contentCANVideo.videoPageUrl ||
                                    listing.contentCANVideo.url ||
                                    '';
                                if (urlAx != '') {
                                    slug = urlAx.replace('live-tv/stream/', '');
                                } else {
                                    slug = 'live-tv/stream';
                                }

                                /**
                                 * if CBS, non-MVPD user and local live in next gen
                                 * Force a full page refresh to get the upsell/lock slate
                                 */
                                if (CBS.Registry.brand.name === 'CBS' && listing.contentCANVideo.status === "PREMIUM") {
                                    window.location.href = "/"+slug+"/";
                                    return;
                                }
                            }
                            let isLiveLocal = false;
                            let replaceurl = '';
                            if (data.payload.channelObj.local) {
                                slug = listing.channelSlug;
                                isLiveLocal = true;
                            }
                            let urlMetadata = '';
                            let station_logo = '';
                            let isLocalCityChannel = false;
                            station_logo = `${CBS.Registry.imageHost}/base/${data.payload.channelObj.filePathSmallLogo}`;
                            if (isNotLiveStreaming) {
                                urlMetadata =
                                    CBS.Registry.region.prefix +
                                    '/live-tv/live-event/' +
                                    slug +
                                    '/' +
                                    listing.contentCANVideo.contentId +
                                    '/metadata.json';
                                //hack for prevent legacy url structure use spa
                                if (listing.contentCANVideo.url.indexOf('shows/') !== -1) {
                                    window.location.replace('/' + listing.contentCANVideo.url);
                                    break;
                                }
                                replaceurl = '/' + listing.contentCANVideo.url + '/';
                            } else {
                                if (
                                    listing.contentCANVideo.showPageUrl.indexOf('cbsn-local/') !==
                                    -1
                                ) {
                                    isLocalCityChannel = true;
                                    slug = listing.channelSlug;
                                }
                                if (isLiveLocal) {
                                    let loc =  DMAStorage.getCurrentLocation();
                                    urlMetadata =
                                        CBS.Registry.region.prefix +
                                        '/live-tv/channels/' +
                                        slug +
                                        '/metadata.json?lat=' +
                                        loc.lat +
                                        '&lon=' +
                                        loc.lon;
                                    if (CBS.Registry.brand.name == 'CBS') {
                                        var mvpdCookie = jQuery.cookie('mvpd_authz');
                                        if (mvpdCookie) {
                                            mvpdCookie = JSON.parse(mvpdCookie);
                                            if (mvpdCookie['mvpd_name']) {
                                                urlMetadata += "&mvpd_name=" + mvpdCookie['mvpd_name'];
                                            }
                                        }
                                    }
                                } else {
                                    urlMetadata =
                                        CBS.Registry.region.prefix +
                                        '/live-tv/channels/' +
                                        slug +
                                        '/metadata.json';
                                }
                                replaceurl =
                                    '/' +
                                    (listing.contentCANVideo.videoPageUrl ??
                                        listing.contentCANVideo.url) +
                                    '/';
                            }
                            let paramsVO = {
                                CONTENT: {
                                    apiMetadata: [listing.contentCANVideo],
                                    refIdForCast: listing.contentCANVideo.contentId ?? '',
                                    contentId: listing.contentCANVideo.contentId ?? '',
                                    country: this.smartTagParams.userCountry || '',
                                    isLive: this.smartTagParams.isLive || false,
                                    drm: {},
                                    globalResumeTime: this.smartTagParams.isLive ? NaN : this.smartTagParams.grestime || 0,
                                    partner: this.smartTagParams.partner || '',
                                    autoplay: this.smartTagParams.autoPlayVid || false,
                                    resource: {
                                        ad: {
                                            ima: {
                                                // extends stalled ad threshold to 30 seconds
                                                stalledAdThreshold: 10,
                                                // disables stalled ads check
                                                enableStalledAdCheck: true
                                            }
                                        },
                                        playback: {
                                            id3OwnerIds: []
                                        }
                                    }
                                },
                                CONTEXT: {
                                    metadata: {}
                                }
                            };
                            // paramsVO = $.extend(true, paramsVO, {
                            //     CONTENT: {
                            //         resource: {
                            //             ad: {
                            //                 dai: { assetKey: listing.contentCANVideo.daistreamKey }
                            //             }
                            //         }
                            //     }
                            // });
                            fetch(urlMetadata)
                                .then((response) => {
                                    return response.json();
                                })
                                .then((resultData) => {
                                    let container = $('.video__metadata');
                                    let title = container.find('p');
                                    let subtitle = container.find('.subTitle');
                                    let description = container.find('.description').text('');
                                    container.find('.description').html('');
                                    container.find('.subTitle').html('');
                                    let desc = container.find('.vodTv__data');
                                    let rating = container.find('.rating');
                                    let logo = container.find('.station__logo img');
                                    if (resultData.success) {
                                        if (resultData.hasOwnProperty('isVpn') && (resultData.isVpn === 'isvpn' || resultData.isVpn === 'irdeto-error')) {
                                            window.location.replace('/' + resultData.metaData.contentUrl);
                                        }
                                        paramsVO.CONTENT.metadata = [resultData.metaData] || [{}];
                                        paramsVO.CONTENT.drm = resultData.CONTENT.drm ?? {};
                                        if (resultData.CONTENT.drm !== undefined) {
                                            paramsVO.CONTENT.millstone = resultData.CONTENT.millstone ?? null;
                                            if (resultData.CONTENT.millstone?.rulesMatched !== undefined) {
                                                paramsVO.CONTEXT.metadata.rulesMatched = resultData.CONTENT.millstone.rulesMatched;
                                            }
                                        }
                                        if (isLiveLocal) {
                                            paramsVO.CONTENT.assetURL = resultData.assetURL ?? '';
                                            paramsVO.CONTENT.contentId = null;
                                            delete paramsVO.CONTENT.pid;
                                        } else {
                                            paramsVO.CONTENT.pid =
                                                listing.contentCANVideo.pid ?? '';
                                            delete paramsVO.CONTENT.assetURL;
                                        }
                                        paramsVO.CONTENT.metadata[0].contentBrand =
                                            resultData.metaData.brand ?? '';
                                       //passing value to utag_data as mops reading the value from utag. the  updated value in utag is not available for spa
                                       utag_data.contentBrand = resultData.metaData.brand ?? '';
                                        paramsVO.CONTENT.resource.playback.id3OwnerIds = [
                                            'www.nielsen.com'
                                        ];
                                        paramsVO.CONTEXT.metadata = resultData.metaData || {};
                                        paramsVO.CONTEXT.metadata.airDate =
                                            resultData.metaData.airdate_iso || '';
                                        paramsVO.CONTEXT.metadata.tvAirDate =
                                            resultData.metaData.airdate_tv || '';
                                        paramsVO.CONTEXT.metadata.mediaType =
                                            resultData.metaData.mediaType || '';
                                        paramsVO.CONTEXT.metadata.streamType = 'LIVE';
                                        paramsVO.CONTEXT.metadata.showGenre =
                                            listing.contentCANVideo.genre &&
                                            listing.contentCANVideo.genre != ''
                                                ? listing.contentCANVideo.genre
                                                : 'other';
                                        // TODO: duplicate code: refactor
                                        if (resultData.metaData.videoProperties &&
                                            (
                                                (typeof resultData.metaData.videoProperties === 'string' && resultData.metaData.videoProperties.indexOf('DVR') > 0

                                        ) ||
                                                (typeof resultData.metaData.videoProperties === 'object' && resultData.metaData.videoProperties.includes('DVR'))
                                            )
                                        ) {
                                            this.smartTagParams.streamType = paramsVO.CONTEXT.metadata.streamType = 'DVR';
                                        }
                                        // TODO: duplicate code: refactor
                                        if (paramsVO.CONTEXT.metadata.streamType) {
                                            paramsVO.CONTEXT.metadata.isDcrLive = paramsVO.CONTENT
                                                .isLive
                                                ? [
                                                      'etl',
                                                      'cbsn',
                                                      'cbs-news',
                                                      'sports_hq',
                                                      'DVR',
                                                      'LIVE'
                                                  ].includes(paramsVO.CONTEXT.metadata.streamType)
                                                : false;
                                        } else {
                                            paramsVO.CONTEXT.metadata.isDcrLive = false;
                                        }

                                        paramsVO.CONTEXT.metadata.showSeasonNumber =
                                            listing.seasonNumber || '';
                                        paramsVO.CONTEXT.metadata.showEpisodeNumber =
                                            listing.episodeNumber || '';
                                        paramsVO.CONTEXT.metadata.showEpisodeTitle =
                                            listing.episodeTitle || '';
                                        paramsVO.CONTEXT.metadata.showId = listing.showId || '';
                                        paramsVO.CONTEXT.metadata.showTitle = listing.title || '';
                                        paramsVO.CONTEXT.metadata.liveVideoTitle =
                                            resultData.metaData.videoTitle || '';
                                        paramsVO.CONTEXT.metadata.episodeTitle =
                                            isLiveLocal? 'Live Local TV' : resultData.metaData.label || '';
                                        paramsVO.CONTEXT.metadata.showSeriesId =
                                            resultData.metaData.showId || '';
                                        paramsVO.CONTEXT.metadata.videoProperties =
                                            resultData.metaData.videoProperties || [];
                                        paramsVO.CONTEXT.metadata.videoProperties =
                                            paramsVO.CONTEXT.metadata.videoProperties.join(', ');
                                        paramsVO.CONTEXT.metadata.liveTvChannel =
                                            resultData.callSignId
                                                ? 'Live Local TV' : data.payload.channelObj.channelName ?? data.payload.channelObj.label ?? '';
                                        paramsVO.CONTEXT.metadata.stationCode =
                                            resultData.callSignId ?? '';
                                        paramsVO.CONTEXT.metadata.userRegId =
                                            utag_data.userRegId || 'anon';
                                        paramsVO.CONTEXT.metadata.userId =
                                            utag_data.userRegId || 'anon';
                                        utag_data.rowHeaderTitle = resultData.callSignId
                                            ? 'Live Local TV' : data.payload.channelObj.channelName ?? data.payload.channelObj.label ?? '';
                                        paramsVO.CONTEXT.metadata.contentBrand =
                                            resultData.metaData.brand ?? '';
                                        paramsVO.CONTEXT.metadata.mediaSvodContentType = listing
                                            .contentCANVideo.subscriptionLevel
                                            ? listing.contentCANVideo.subscriptionLevel.toLowerCase()
                                            : '';
                                        utag_data.mediaSvodContentType = (this.smartTagParams.isPaidContent) ? 'paid' : 'free';
                                        paramsVO.CONTEXT.metadata.bundleStatus = CBS.Registry.user.bundleStatus ?? '';
                                        paramsVO.CONTEXT.metadata.userStatus = this.smartTagParams.userStatus || CBS.Registry.user.sb;
                                        if (localStorage.getItem('channelBrowseCategory')) {
                                            paramsVO.CONTEXT.metadata.channelBrowseCategory =
                                                localStorage.getItem('channelBrowseCategory');
                                            utag_data.channelBrowseCategory =
                                                paramsVO.CONTEXT.metadata.channelBrowseCategory;
                                        } else {
                                            paramsVO.CONTEXT.metadata.channelBrowseCategory = 'all';
                                            utag_data.channelBrowseCategory = 'all';
                                        }
                                        if (localStorage.getItem('spliceEnabled')) {
                                            paramsVO.CONTEXT.metadata['spliceEnabled'] =
                                                localStorage.getItem('spliceEnabled');
                                            localStorage.removeItem('spliceEnabled');
                                        }
                                        if (resultData.CONTENT.drm) {
                                            paramsVO.CONTEXT.metadata.drmName = (resultData.CONTENT.drm.name) ? resultData.CONTENT.drm.name : 'none';
                                        } else {
                                            paramsVO.CONTEXT.metadata.drmName = 'none';
                                        }
                                        paramsVO.CONTEXT.metadata.pageTitle = document.title;
                                        utag_data.pageTitle = document.title;
                                        utag_data.videoTitle = resultData.metaData.videoTitle;
                                        paramsVO.CONTEXT.metadata.videoTitle =
                                            resultData.metaData.videoTitle ?? '';
                                        paramsVO.CONTEXT.metadata.videoId =
                                            listing.videoContentId || '';

                                        const posColNum = sessionStorage.getItem('posColNum');
                                        const posRowNum = sessionStorage.getItem('posRowNum');
                                        paramsVO.CONTEXT.metadata.posColNum =
                                            posColNum ?? 'undefined';
                                        paramsVO.CONTEXT.metadata.posRowNum =
                                            posRowNum ?? 'undefined';

                                        // html changes
                                        logo.attr('src', station_logo);
                                        logo.attr(
                                            'alt',
                                            (resultData.metaData.brand ||
                                                resultData.metaData.contentBrand) + ' LOGO'
                                        );
                                        title.html(
                                            (resultData.callSignId)
                                                ? resultData.callSignId
                                                : isLocalCityChannel
                                                ? resultData.metaData.showTitle // what resultData.title but incorrect for standard local channels
                                                : ''
                                        );
                                        if (isNotLiveStreaming) {
                                            title.text(resultData.metaData.showTitle ?? '');
                                            subtitle.html(resultData.listing.description ?? '');
                                        }
                                        if (!data.payload.blockPushState) {
                                            window.history.pushState('', '', replaceurl);
                                        }
                                        document.title =
                                            resultData.metaData.brand ||
                                            resultData.metaData.contentBrand;
                                        if (CBS.Registry.brand.name == 'PPLUS') {
                                            document.title += ' On Paramount Plus';
                                        } else {
                                            document.title += ' On CBS';
                                        }
                                        //For checking the the video is live game
                                        if (
                                            isNotLiveStreaming &&
                                            data.payload.channelObj.videoContentId === '000000'
                                        ) {
                                            rating.html(resultData.rating);
                                            title.html(resultData.title);
                                            subtitle.html(resultData.subtitle);
                                            rating.html(resultData.raitings);
                                            duration.html(resultData.duration);
                                            description.html(resultData.listing.description);
                                            desc.removeClass('hidden');
                                        } else {
                                            subtitle.html(
                                                isLocalCityChannel
                                                    ? ''
                                                    : resultData.callSignId
                                                    ? ''
                                                    : resultData.metaData.description
                                            );
                                            desc.addClass('hidden');
                                        }

                                        // fix/hack for VOD to Live Channels
                                        if (resultData.title == "Paramount+ Channels") {
                                            title.html(resultData.listing.title ?? "");
                                            container.find('.description').html("");
                                            container.find('.subTitle').html(resultData.listing.description ?? "");
                                        }

                                        utag_data.url = document.location.href;
                                        paramsVO.CONTEXT.metadata.pageType = 'video';
                                        paramsVO.CONTEXT.metadata._pageType = 'video';
                                        // trackState call
                                        const trackStateObj = {
                                            showGenre: paramsVO.CONTEXT.metadata.showGenre ?? '',
                                            posColNum: paramsVO.CONTEXT.metadata.posColNum,
                                            posRowNum: paramsVO.CONTEXT.metadata.posRowNum,
                                            liveTvChannel: paramsVO.CONTEXT.metadata.liveTvChannel,
                                            userRegId: paramsVO.CONTEXT.metadata.userRegId,
                                            userType: utag_data.userType,
                                            userStatus: this.smartTagParams.userStatus ?? '',
                                            videoTitle: paramsVO.CONTEXT.metadata.videoTitle ?? '',
                                            liveStreamStation: paramsVO.CONTEXT.metadata.stationCode ?? '',
                                            userProfileId: CBS.Registry.user.profile_id ?? '',
                                            userProfileMaster: CBS.Registry.user.userProfileMaster ? 'true' : 'false',
                                            userProfileCategory:
                                                CBS.Registry.user.profile_type ?? '',
                                            pageViewGuid: window.__page_uuid,
                                            brandPlatformId:
                                                CBS.Registry.brand_platform_desktop_id || '',
                                            contentBrand: resultData.metaData.brand ?? '',
                                            pageType: 'live-tv',
                                            pageTitle: document.title,
                                            pageUrl: document.location.href,
                                            stationCode: resultData.callSignId ?? '',
                                            channelBrowseCategory:
                                                paramsVO.CONTEXT.metadata.channelBrowseCategory ??
                                                'all',
                                            rowHeaderTitle: utag_data.rowHeaderTitle
                                        };
                                        om.trackState(trackStateObj);
                                        // end trackState call
                                        this.smartTagVO.API.VIDEO.load(paramsVO);
                                        this.smartTagVO.API.SKIN.pageAction({
                                            action: 'PageAction.RELOAD_SCHEDULE',
                                            data: resultData
                                        });

                                        // skip if chromecast api is not available
                                        if (Helper.isEmptyObject(this.api.CastNS)) {
                                            return;
                                        }
                                        try {
                                            // set params for chromecast so it's ready to stream any moment
                                            this.updateChromecastParams(listing, paramsVO);
                                            if (
                                                !!data?.payload?.isSPA &&
                                                this.api.CastNS.isConnected()
                                            ) {
                                                this.api.CastNS.uiReady();
                                            }
                                        } catch (e) {
                                            console.log('Failed to start cast session.', e);
                                        }
                                    }
                                })
                                .catch(function (err) {
                                    console.log(err);
                                });
                            return new Promise(function (resolve) {
                                resolve();
                            });
                            break;
                    }
                },
                getScheduleData: () => {
                    return this.scheduleAPIData;
                }
            },
            onSmartTagAction: (event) => {
                this.onSmartTagAction(event);
            },
            CastToLocalAdapter: {},
            pollABState: () => {
                return this.pollABState();
            },
            pageAction: (action) => {
                // possible race condition? check for null: CBSSITE-10928
                if (this.smartTagVO) {
                    this.smartTagVO.API.SKIN.pageAction(action);
                }
            },
            checkContext: (context) => {
                return context.country !== 'us';
            }
        });
    }

    addPromiseToWaitFor(promise) {
        if (promise && promise instanceof Promise) {
            this.promisesToWaitFor.push(promise);
        }
    }

    initContinuousPlayTracking() {
        try {
            let _data = JSON.parse(localStorage.getItem('cbs_cp')) || {};

            let cp = _data.cp || {}; // Continuous Play session data
            let endcardContentId = JSON.parse(sessionStorage.getItem('contentID')) || '';

            if (endcardContentId !== this.metaData.contentId) {
                cp = {};
            }
            //check object not empty
            if (cp && Object.keys(cp).length > 0) {
                Object.keys(cp).forEach((key) => {
                    this.cpHBTracking[key] = cp[key];
                    if (key === 'contPlayState') {
                        this.__cpPre = true;
                        this.__cpsession = '1';
                    }
                });
            }
        } catch (e) {
            console.log('Unexpected error in initContinuousPlayTracking:', e);
        }

        this.eraseContinuousPlaySessionData(); // Clean up CP session data
    }

    onPinAction(obj) {
        let tracking = null;
        if (CBS.Registry.parentalControlTracking !== undefined) {
            // AU, CA
            tracking = new CBS.Registry.parentalControlTracking();
        } else {
            // Domestic
            tracking = new VideoPagePinTrackingService();
        }
        // Parse SmartTag call payload (decode payload from base64 to object if base64 format is detected)
        let payload = this.isBase64(obj.payload) ? this.decodeBase64(obj.payload) : obj.payload;
        switch (payload.action) {
            case 'Display':
                tracking && tracking.pinView();
                break;
            case 'Check':
                if (payload.pin !== undefined) {
                    let promise = PinHelper.validatePin(payload.pin, this._contentId);
                    promise.then(
                        (isvalid) => {
                            if (isvalid) {
                                tracking && tracking.pinOk();
                                this.pinGateResolver(true);
                            } else {
                                tracking && tracking.pinFail();
                            }
                            obj.callback(isvalid);
                        },
                        function () {
                            obj.callback(false);
                        }
                    );
                }
                break;
            case 'Cancel':
                tracking && tracking.pinCancel();
                // AU/CA cancel: redirect to home page
                window.location = '/';
                break;
            case 'Forgot':
                tracking && tracking.pinForgot();
                if (CBS.Registry.brand.property == 'AU' || CBS.Registry.brand.property == 'CA') {
                    window.location = '/account/?#forgot-pin';
                } else {
                    window.location = '/account/?target=forgot-pin';
                }
                break;
        }
    }

    /**
     * Determine if a string is base64 encoded
     * @param string str. The string
     * @returns boolean
     */
    isBase64(str) {
        return (
            str.match(
                new RegExp(
                    '^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$'
                )
            ) !== null
        );
    }

    /**
     * Decode base 64 string
     * @param string str - the encoded string
     * @returns string - decoded string
     */
    decodeBase64(str) {
        return JSON.parse(atob(decodeURI(str)));
    }


    /**
     * Function called by smartTag asking page to erase CP local storage session data
     * when next CP video metadata is unavailable
     */
    eraseContinuousPlaySessionData() {
        localStorage.setItem('cbs_cp', JSON.stringify({}));
        document.cookie = 'CBS_CP=0;path=/';
    }

    /**
     * @description Callback method called by the individual Tag application created in onSmartTagReady
     * @param {{type:String, tag:Tag}} event
     */
    tagCallback = (event) => {
        switch (event.type) {
            case 'TagEvent.ON_CREATE_PLAYER_REQUEST':
                if (typeof vtg !== 'undefined') {
                    vtg.config.Sparrow.params.serverInfo.serverUrl =
                        CBS.Registry.sparrowHost.replace(/(^\w+:|^)\/\//, '');
                }
                break;
            case 'TagEvent.ON_READY':
                this.smartTagVO = event.tag; // store Tag application reference
                // request Tag to load the content
                this.smartTagLoadResolver(true);
                if (this.smartTagParams.showSkinSideBar) {
                    this.activateSkinSideBar();
                }

                Promise.all(this.promisesToWaitFor).then(() => {
                    let paramsVO = null;
                    // if playready drm (e.g. Edge Chromium on Windows 10): Bug in CVP's default Shaka player adaptor
                    // if (typeof this.CONTENT.drm !== 'undefined' && typeof this.CONTENT.drm.playready !== 'undefined' && !$.isEmptyObject(this.CONTENT.drm.playready) ) {
                    if (
                        typeof window.CBS.Registry.drmPromise !== 'undefined' &&
                        window.CBS.Registry.drmPromise !== null
                    ) {
                        paramsVO = $.extend(true, paramsVO, { CONTENT: { drm: this.CONTENT.drm } });
                    }

                    if (utag_data) {
                        paramsVO = $.extend(true, paramsVO, { CONTEXT: { metadata: utag_data } });
                    }

                    // Note, for now, load() CANNOT take null else it will nuke all the params - might be fixed?
                    if (paramsVO !== null) {
                        this.smartTagVO.API.VIDEO.load(paramsVO);
                    } else {
                        this.smartTagVO.API.VIDEO.load();
                    }
                });

                let isEdgeChromium = window.navigator.userAgent.toLowerCase().indexOf('edg/') > -1;
                let isChrome = window.navigator.userAgent.toLowerCase().indexOf('chrome/') > -1;
                if (isChrome || isEdgeChromium)
                    $.getScript(
                        'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1'
                    );

                if (this.castSender) {
                    this.api.CastToLocalAdapter = new SmartTagCastAPI(this.smartTagVO);
                    this.api.CastToLocalAdapter.ready();
                }

                this.playerLoadResolver(true);
                break;

            case 'TagEvent.ON_PLAYER_EVENT':
                switch (event.data.playerEvent.type ?? '') {
                    case 'PlayerEvent.TAG_PLAYER_STATE_CHANGE':
                        if (typeof this.onPlayerStateChanged === 'function') {
                            this.onPlayerStateChanged(event.data.playerEvent.data.playerState);
                        }
                        break;

                    // Event for when the video starts playing
                    case 'contentstart':

                        //calling braze custom event
                        const show = utag_data ? utag_data.show : undefined;
                        const episodeTitle = utag_data ? utag_data.episodeTitle : undefined;

                        if (CBS.Registry.Features.braze_sdk === true)
                            import('shared/braze_events/events').then(({ onViewVideo }) => {
                                onViewVideo(show, episodeTitle);
                            });

                        //only trigger for clips on mobile web
                        const isMobile = CBS.Registry.platform.isMobile;
                        const isClip = this.metaData.mediaType?.toLowerCase() === 'clip';

                        if (isMobile && isClip) {
                            //safely get required values with fallbacks
                            const regionPrefix = (CBS.Registry.region?.prefix || '').trim();
                            const contentId = this._contentId || '';
                            const showId = this.showId || '';
                            const endCardId = this.metaData.contentId || contentId || '';
                            const mediaType = this.metaData.mediaType ?? '';

                            // Position from query param
                            let position = 0;
                            const queryString = window.location.search;
                            const urlParams = new URLSearchParams(queryString);
                            position = parseInt(urlParams.get('p') || '0', 10);

                            //A/B Test flag
                            const abtest = window.nextShowsAbTest === true ? '1' : '0';

                            //build base URL
                            const baseUrl = `${CBS.Registry.region.prefix}/video/endcard/up-next.json`;

                            //prepare params manually to ensure validity
                            const params = new URLSearchParams();
                            params.append('contentType', mediaType);
                            params.append('endCardId', endCardId);
                            params.append('contentId', contentId);
                            params.append('mediaType', mediaType);
                            params.append('var', abtest);
                            if (isClip) {
                                params.append('showId', showId);
                                params.append('position', String(position));
                            }

                            //final URL
                            const finalUrl = `${baseUrl}?${params.toString()}`;

                            //make safe request
                            fetch(finalUrl)
                                .then((response) => {
                                    return response.json()
                                })
                                .then((response) => {
                                    this.clipNextUrl = response.result.apiResponse[0].videoPageURL?.trim();
                                })
                                .catch(error => {
                                    console.error('Failed to fetch up-next clip data:', error);
                                });
                        }

                        break;

                    case 'contentcomplete':
                        const isDeviceMobile = CBS.Registry.platform.isMobile;
                        const isVideoClip = this.metaData.mediaType?.toLowerCase() === 'clip';
                        if(this.clipNextUrl !== null && isVideoClip === true && isDeviceMobile === true) {
                            window.location.href = this.clipNextUrl;
                        }
                        break;
                }
                break;
            case 'TagEvent.ON_API_REPLAY_VIDEO_REQUEST':
                this.smartTagVO = event.tag;

                Promise.all(this.promisesToWaitFor).then(() => {
                    let paramsVO = {
                        CONTENT: this.initialParamsVO.CONTENT,
                        CONTEXT: this.initialParamsVO.CONTEXT
                    };
                    if (paramsVO.CONTEXT.metadata.streamType !== 'DVR') {
                        paramsVO = $.extend(true, paramsVO, {
                            CONTENT: {
                                resource: {
                                    playback: {
                                        startTime: 0
                                    }
                                }
                            }
                        });
                    }
                    this.smartTagVO.API.VIDEO.load(paramsVO);
                    handleSmartTagOverlay();
                });
                break;
        }
    };

    tagAction = (data) => {
        switch (data.action) {
            case 'TagAction.GET_SESSION_DATA':
                return new Promise(async (resolve, reject) => {
                    const videoAdSessionValues = await this.getVideoAdSessionValues()
                    resolve({ sessionData: videoAdSessionValues });
                });
        }
    };

    /**
     * @description SmartTag ready callback. Called upon SmartTag application load and initialization success
     * @param {SmartTag} smartTag
     */
    onSmartTagReady = (smartTag) => {
        const readyEvent = new CustomEvent('SMART_TAG_ADAPTER.READY', {
            detail: {
                adapterInstance: this
            }
        });
        document.dispatchEvent(readyEvent);
        this.initContinuousPlayTracking();

        let utagMetadata = utag_data ? utag_data : {};
            let cpMetadata =  [];
            let isKids = false;
            window.localStorage.setItem(
                'set_continuous_movie',
                JSON.stringify({ continuous_movie: true })
            );
            
            if (
                this.metaData.videoProperties !== undefined &&
                this.metaData.videoProperties.indexOf(KIDS) !== -1 &&
                (this.metaData.mediaType === 'Movie' || this.metaData.mediaType === 'Standalone')
            ) {
                isKids = true;
                this.redirectUrl = localStorage.getItem('cpRedirect') ?? null;
            }
            if(localStorage.getItem('cpRedirect')){
                localStorage.removeItem('cpRedirect');
            }
            var _cp = undefined;
            var _fch = undefined;
            var shouldDisableEndCard = this.metaData.mediaType !== undefined && this.metaData.mediaType.toLowerCase() === 'clip';
            if (this.fch) {
                _fch = {...this.fch, endCreditsChapterTime: this.metaData.endCreditsChapterTime || '', contentType: this.contentType};
            } else  {
                // Default to 30 seconds before end of video
                let endCreditsChapterTime = this.metaData.videoLength - 30;

                _cp = {
                    enabled: this.enableCP == 1 && this.enableCP == '1' ? true : false,
                    endCreditsChapterTime:
                        this.metaData.endCreditsChapterTime || endCreditsChapterTime,
                    redirectUrl: isKids == true ? this.redirectUrl : null,
                    countdownTime: (shouldDisableEndCard ? 0.1 : (this.showId && this.showId != -1 ? 10 : 30))
                };
            }
            
            // is NextUI active ?
            let nextUiActive = this.smartTagParams.showSkinSideBar ?? false;
            // set Convia A/B testBucket value
            utagMetadata.testBucket = this.smartTagParams.testBucket;
            utag_data.isSPA = this.smartTagParams.skinSideBarIsSPA ?? false;

            //disable pause ads for pid-based live streams like UEFA
            //also to disable ads from Paramount+ for user tier not TIER_CF/0
            let pauseAd = (nextUiActive) ? false : true;
            if (!nextUiActive) {
                if (
                    (this.smartTagParams.isLive === true && this.smartTagParams.pid != null) ||
                    (CBS.Registry.brand.name === 'PPLUS' &&
                        CBS.Registry.user.profile_type !== ADULT) || (this.metaData.videoProperties && this.metaData.videoProperties.indexOf(KIDS) > -1) ||
                    (CBS.Registry.brand.name === 'PPLUS' && (CBS.Registry.user.isLC !== true && CBS.Registry.user.isLCP !== true))
                ) {
                    pauseAd = false;
                }
            }
            // setup Tag parameters object
            let paramsVO = {
                // tag application parameters
                TAG: {
                    container: $('cbsplayer'),
                    callback: this.smartTagParams.callback,
                    namespace: {
                        TAG: this.smartTagParams.jsNS,
                        CAST: this.smartTagParams.castNS, // Chromecast namespace. Tag is going to call Chromecast related methods on this namespace
                        PINGate: this.smartTagParams.PINGateNS, // PIN Gate namespace. Tag is going to call PIN Gate related methods on this namespace
                        SKIN: this.smartTagParams.skinNS,
                        CP: this.api.ContinuousPlayNS
                    },
                    config: {
                        tag: [
                            {
                                ErrorCopy: ErrorCopy
                            }
                        ],
                        skin: [
                            {
                                EndCards: {
                                    params: {
                                        showCardEnabled: !shouldDisableEndCard,
                                    }
                                }
                            },
                            {
                                SkinSideBarPlugin: {
                                    enabled: nextUiActive,
                                    params: {
                                        config: {
                                            isSPA: this.smartTagParams.skinSideBarIsSPA ?? false,
                                            localTvLockOverride: true
                                        }
                                    }
                                },
                                END_DVR_LIVE_STREAM: {
                                    enabled: true,
                                    params: {
                                        inactivityTimeout: 20,
                                        getNextChannelEnabled: CBS.Registry.Features.live_tv_end_card ?? false
                                    }
                                },

                                },

                            {
                                Settings: {
                                    params: {
                                        Controls: {
                                            ltsFeatureTooltip: {
                                                enabled: true
                                            }
                                        }
                                    }
                                }
                            },
                            {
                                PauseAd: {
                                    enabled: pauseAd,
                                    params: {
                                        provider: 'FREEWHEEL'
                                    }
                                }
                            },
                            {
                                Copy: {
                                    params: {
                                        Copy: {
                                            CONTROLS: {
                                                STATUS: {
                                                    LIVE: getLocale('lts_status_live')
                                                },
                                                DVR: {
                                                    GO_LIVE: getLocale('lts_status_dvr')
                                                },
                                                LTS_FEATURE_TOOLTIP: {
                                                    MESSAGE: getLocale('lts_tooltip_text'),
                                                    BUTTON: getLocale('lts_tooltip_button_text')
                                                }
                                            },
                                            VOD_TIMEOUT: {
                                                STILL_WATCHING: getLocale(
                                                    'still_watching_no_questionmark'
                                                ),
                                                YES_KEEP_WATCHING: getLocale('yes_keep_watching'),
                                                YES_DONT_ASK_AGAIN: getLocale(
                                                    'yes_and_do_not_ask_me_again'
                                                ),
                                                NO_GOTO_HOMEPAGE: getLocale('no_go_to_homepage')
                                            },
                                            END_DVR_LIVE_STREAM: {
                                                DVR_MSG: getLocale(
                                                    'your_content_has_ended_but_theres_still_more_to_stream'
                                                )
                                            }
                                        }
                                    }
                                }
                            }

                        ]
                    }
                },
                // ad related parameters
                AD: {
                    AB: {
                        method: this.api.pollABState,
                        interval: 5000,
                        delay: 7000
                    }
                },
                CONTENT: {
                    metadata: [this.metaData] || [{}],
                    apiMetadata: this.apiMetadata,
                    refIdForCast: this.smartTagParams._contentID || '',
                    assetURL: this.smartTagParams.assetURL || '',
                    drm: this.CONTENT.drm || {},
                    autoplay: this.smartTagParams.autoPlayVid || false,
                    globalResumeTime: this.smartTagParams.isLive ? NaN : this.smartTagParams.grestime || 0,
                    partner: this.smartTagParams.partner || '',
                    country: this.smartTagParams.userCountry || '',
                    isLive: this.smartTagParams.isLive || false,
                    resource: {
                        ad: {
                            ima: {
                                // extends stalled ad threshold to 30 seconds
                                stalledAdThreshold: 10,
                                // disables stalled ads check
                                enableStalledAdCheck: true
                            }
                        },
                        playback: {
                            id3OwnerIds: []
                        }
                    }
                },
                CONTEXT: {
                    metadata: utagMetadata
                },
                // skin related parameters
                SKIN: {
                    //liveStreamTimeout: 10,
                    //liveStreamTimeoutCountdown: 5
                    cp: _cp,
                    fch: _fch,
                    brandLogoUrl: this.smartTagParams.isLive ? '' : this.brandLogoUrl,
                },
                USER: {
                    userStatus: this.smartTagParams.userStatus || CBS.Registry.user.sb,
                    bundleStatus: this.smartTagParams.bundleStatus ?? '',
                    packageSource: this.smartTagParams.packageSource ?? '',
                    usPrivacy: jQuery.cookie('usprivacy') ?? '',
                    userId: CBS.Registry.user.id || '',
                    profileId: CBS.Registry.user.profile_id ?? '',
                    mvpdId: this.smartTagParams.mvpdId || '',
                    pinGate: this.smartTagParams.pinCheck // enable / disable PIN Gate
                }
            };
            if (this.lowbandEnabled) {
                paramsVO.CONTENT.resource.playback.abr = {
                    maxBitrate: LOW_BIT_2MBPS
                };
            }
            if (this.CONTENT.millstone !== undefined) {
                paramsVO.CONTENT.millstone = this.CONTENT.millstone ?? null;
                if (this.CONTENT.millstone.rulesMatched !== undefined) {
                    paramsVO.CONTEXT.metadata.rulesMatched = this.CONTENT.millstone.rulesMatched;
                }
            }
            if (Domain.isDomestic()) {
                paramsVO.CONTENT.pid = this.metaData.pid || '';
            }

            // episodeFlag is the boolean for enabling sparrow tracking
            // Pass through context.metadata vs. paramsVO.CONTENT.resource.metadata
            paramsVO.CONTEXT.metadata.episodeFlag = !!this.metaData.fullEpisode;

            if (Domain.isInternational()) {
                paramsVO.CONTENT.resource.playback.startTime = this.smartTagParams.medTime;
                import(
                    /* webpackChunkName: "skin-copy" */
                    'video/skinCopy'
                ).then(({ SkinCopy }) => {
                    paramsVO['TAG']['config']['skin'][0]['Copy'] = {
                        params: {
                            Copy: SkinCopy
                        }
                    };
                });
                import(
                    /* webpackChunkName: "aria-labels" */
                    'video/ariaLabels'
                ).then(({ AriaLabels }) => {
                    paramsVO['TAG']['config']['skin'].push({
                        Aria: {
                            params: {
                                Aria: AriaLabels
                            }
                        }
                    });
                });
            }
            
            //pass daistreamKey as assetKey to smart tag for pid-based live streams (i.e. UEFA)
            // if (
            //     this.smartTagParams.isLive === true &&
            //     this.smartTagParams.pid &&
            //     this.metaData.daistreamKey
            // ) {
            //     paramsVO = $.extend(true, paramsVO, {
            //         CONTENT: {
            //             resource: { ad: { dai: { assetKey: this.metaData.daistreamKey } } }
            //         }
            //     });
            // }

            //accounts for uefa live streams within a VOD page that does not have liveStreamMetadata defined
            if (
                this.smartTagParams.isLive === true &&
                this.smartTagParams.liveStreamMetadata == undefined &&
                this.metaData
            ) {
                this.smartTagParams.liveStreamMetadata = this.metaData;
            }
            paramsVO.CONTENT.locale = CBS.Registry.region.locale;
            if (paramsVO.CONTEXT.metadata.pageType === 'movie') {
                paramsVO.CONTEXT.metadata.pageType = 'video';
            }
            paramsVO.CONTEXT.metadata.bundleStatus = this.smartTagParams.bundleStatus ?? '';
            utag_data.bundleStatus = paramsVO.CONTEXT.metadata.bundleStatus;
            paramsVO.CONTEXT.metadata.airDate = this.metaData.airdate_iso || '';
            paramsVO.CONTEXT.metadata.tvAirDate = this.metaData.airdate_tv || '';
            if (this.smartTagParams.isLive) {
                paramsVO.CONTEXT.metadata.showGenre =
                    this.apiMetadata?.[0]?.genre?.length > 0 ? this.apiMetadata[0].genre : 'other';
            }
            paramsVO.CONTEXT.metadata.mediaType =
                this.smartTagParams.isLive === true
                    ? this.smartTagParams.liveStreamMetadata.mediaType || ''
                    : this.metaData.mediaType || '';
            paramsVO.CONTEXT.metadata.partner = this.smartTagParams.partner || '';
            paramsVO.CONTEXT.metadata.country = this.smartTagParams.userCountry || '';
            paramsVO.CONTEXT.metadata.videoId = this.smartTagParams._contentID || '';
            paramsVO.CONTEXT.metadata.streamType =
                this.smartTagParams.isLive === true ? 'LIVE' : 'VOD';
            if (this.metaData.videoProperties &&
                (
                    (typeof this.metaData.videoProperties === 'string' && this.metaData.videoProperties.indexOf('DVR') > 0) ||
                    (typeof this.metaData.videoProperties === 'object' && this.metaData.videoProperties.includes('DVR'))
                )
                ) {
                this.smartTagParams.streamType = paramsVO.CONTEXT.metadata.streamType = 'DVR';
            }
            paramsVO.CONTEXT.metadata.videoTitle =
                this.videoTitle !== '' ? this.videoTitle : utagMetadata.showEpisodeTitle;
            paramsVO.CONTEXT.metadata.liveVideoTitle =
                this.smartTagParams.isLive === true ? this.videoTitle : '';
            paramsVO.CONTEXT.metadata.episodeTitle =
                this.smartTagParams.isLive === true
                    ? this.smartTagParams.liveStreamMetadata.label || ''
                    : this.metaData.label || '';
            paramsVO.CONTEXT.metadata.contentBrand =
                this.smartTagParams.isLive === true
                    ? this.smartTagParams.liveStreamMetadata.brand || ''
                    : this.metaData.brand || '';
            paramsVO.CONTEXT.metadata.showSeriesId = this.showId || '';
            paramsVO.CONTEXT.metadata.videoProperties =
                this.smartTagParams.isLive === true
                    ? this.smartTagParams.liveStreamMetadata.videoProperties || []
                    : this.metaData.videoProperties || [];
            paramsVO.CONTEXT.metadata.videoProperties =
                paramsVO.CONTEXT.metadata.videoProperties.join(', ');
            paramsVO.CONTENT.resource.playback.id3OwnerIds =
                this.smartTagParams.isLive === true ? ['www.nielsen.com'] : [];
            // For VOD to Live with DRM
            if (
                this.smartTagParams.CONTEXT &&
                this.smartTagParams.CONTEXT.metadata &&
                this.smartTagParams.CONTEXT.metadata.drmName
            ) {
                paramsVO.CONTEXT.metadata.drmName = this.smartTagParams.CONTEXT.metadata.drmName;
            } else {
                paramsVO.CONTEXT.metadata.drmName = paramsVO.CONTEXT.metadata.drmName || 'none';
            }
            paramsVO.CONTEXT.metadata.userRegId = paramsVO.CONTEXT.metadata.userRegId || 'anon';

            if (this.cpHBTracking.contPlayState) {
                Object.keys(this.cpHBTracking).forEach((key) => {
                    paramsVO.CONTEXT.metadata[key] = this.cpHBTracking[key]
                })
            }

            if (paramsVO.CONTEXT.metadata.streamType) {
                paramsVO.CONTEXT.metadata.isDcrLive = this.smartTagParams.isLive
                    ? ['etl', 'cbsn', 'cbs-news', 'sports_hq', 'DVR', 'LIVE'].includes(
                          paramsVO.CONTEXT.metadata.streamType
                      )
                    : false;
            } else {
                paramsVO.CONTEXT.metadata.isDcrLive = false;
            }

            utag_data.url = document.location.href;
            paramsVO.CONTEXT.metadata.rowHeaderTitle = this.metaData.rowHeaderTitle || '';
            paramsVO.CONTEXT.metadata.posRowNum = this.metaData.posRowNum || '';
            paramsVO.CONTEXT.metadata.posColNum = this.metaData.posColNum || '';
            paramsVO.CONTEXT.metadata.showSeasonNumber = this.metaData.seasonNumber || '';
            paramsVO.CONTEXT.metadata.showEpisodeNumber = this.metaData.episodeNumber || '';
            paramsVO.CONTEXT.metadata.seriesTitle =
                this.smartTagParams.liveStreamMetadata &&
                this.smartTagParams.liveStreamMetadata.seriesTitle
                    ? this.smartTagParams.liveStreamMetadata.seriesTitle
                    : '';
            paramsVO.CONTEXT.metadata.showTitle = utag_data.seriesTitle || '';
            if (this.smartTagParams.isLive) {
                if (localStorage.getItem('channelBrowseCategory')) {
                    paramsVO.CONTEXT.metadata.channelBrowseCategory = localStorage.getItem('channelBrowseCategory');
                    localStorage.removeItem('channelBrowseCategory');
                } else {
                    paramsVO.CONTEXT.metadata.channelBrowseCategory = 'all';
                }
                paramsVO.CONTEXT.metadata.posColNum = sessionStorage.getItem('posColNum');
                paramsVO.CONTEXT.metadata.posRowNum = sessionStorage.getItem('posRowNum');
                paramsVO.CONTEXT.metadata.mediaSvodContentType = (this.smartTagParams.isPaidContent) ? 'paid' : 'free';
                paramsVO.CONTEXT.metadata._pageType = 'video';
                utag_data.pageType = 'video';
                paramsVO.CONTEXT.metadata.isLive = true;
                if (localStorage.getItem('on_now_carousel')) {
                    const _liveTvChannel = JSON.parse(localStorage.getItem('on_now_carousel'));
                    paramsVO.CONTEXT.metadata.liveTvChannel =
                        _liveTvChannel.liveTvChannel ?? 'undefined';
                    paramsVO.CONTEXT.metadata.stationCode =
                        _liveTvChannel.stationCode ?? 'undefined';
                    paramsVO.CONTEXT.metadata.channelBrowseCategory = 'all';
                    utag_data.channelBrowseCategory = 'all';
                    localStorage.removeItem('on_now_carousel');
                }
                if (this.smartTagParams.channelName) {
                    utag_data.rowHeaderTitle = this.smartTagParams.channelName == "CBS News Live Stream" ? "CBS News" : this.smartTagParams.channelName;
                    paramsVO.CONTEXT.metadata.liveTvChannel = utag_data.rowHeaderTitle;
                } else {
                    utag_data.rowHeaderTitle = this.smartTagParams.liveStreamMetadata.channelName ??
                    this.smartTagParams.liveStreamMetadata.label;

                    paramsVO.CONTEXT.metadata.liveTvChannel = utag_data.rowHeaderTitle ??
                        this.smartTagParams.liveStreamMetadata.channelName ??
                        this.smartTagParams.liveStreamMetadata.label;
                }
            }
            // extra metadata-video-tracking
            const obj = extraMeta();
            if (obj) {
                paramsVO.CONTEXT.metadata.rowHeaderTitle = obj.rowHeaderTitle;
                paramsVO.CONTEXT.metadata.posRowNum = obj.posRowNum;
                paramsVO.CONTEXT.metadata.posColNum = obj.posColNum;
                paramsVO.CONTEXT.metadata.showSeasonNumber = obj.showSeasonNumber;
                paramsVO.CONTEXT.metadata.showEpisodeNumber = obj.showEpisodeNumber;
            }

            if (localStorage.getItem('trackHeroCtaText')) {
                const trackHeroCtaText = JSON.parse(localStorage.getItem('trackHeroCtaText'));
                paramsVO.CONTEXT.metadata.ctaText = trackHeroCtaText.ctaText;
                localStorage.removeItem('trackHeroCtaText');
            }

            if (localStorage.getItem('trackMovieBrowseTileSelect')) {
                const objMovie = JSON.parse(localStorage.getItem('trackMovieBrowseTileSelect'));
                paramsVO.CONTEXT.metadata.pageType = 'video';
                paramsVO.CONTEXT.metadata.screenName = objMovie.screenName;
                paramsVO.CONTEXT.metadata.movieBrowseCategory = objMovie.movieBrowseCategory;
                paramsVO.CONTEXT.metadata.movieGenre = objMovie.movieGenre;
                paramsVO.CONTEXT.metadata.movieId = objMovie.movieId;
                paramsVO.CONTEXT.metadata.movieTitle = objMovie.movieTitle;
                paramsVO.CONTEXT.metadata.PPlusSubscriberBadge = objMovie.PPlusSubscriberBadge;
                localStorage.removeItem('trackMovieBrowseTileSelect');
            }

            // is this a schedule referral?
            if (localStorage.getItem('cbs_nsr') == 1) {
                paramsVO.CONTEXT.metadata.networkSelectionReferral = 1;
                localStorage.setItem('cbs_nsr', 0);
            }

            // START ABTest: homepage descriptions
            paramsVO.CONTEXT.metadata.carouselTile = this.metaData.carouselTile || '';
            paramsVO.CONTEXT.metadata.spliceEnabled = this.metaData.spliceEnabled || '';
            // END ABTest: homepage descriptions

            if (
                paramsVO.CONTEXT.metadata.spliceEnabled == '' &&
                localStorage.getItem('spliceEnabled')
            ) {
                paramsVO.CONTEXT.metadata['spliceEnabled'] = localStorage.getItem('spliceEnabled');
                localStorage.removeItem('spliceEnabled');
            }

            Promise.all(this.promisesToWaitFor).then((extraParams) => {
                extraParams.forEach((params) => {
                    $.extend(true, paramsVO, params);
                });
                $.extend(true, paramsVO.AD, this.AD);
                this.initialParamsVO = $.extend(true, this.initialParamsVO, paramsVO);

                smartTag.create(paramsVO);
            });
    };

    /**
     * @description This method is called by SmartTag, asking page to replay resource.
     * In Live assetURL type playback case => update assetURL and send updated resource config back to SmartTag for playback
     * @param {{callback:Function, resourceConfig: ResourceConfigurationInterface, updateResource:boolean}} data
     */
    replayResource = (data) => {
        //defined in LiveStreamPlayer.js
    };

    /**
     * Function called by smartTag for Continuous Play
     * @param {Object} objMediaTrackingMetadata
     */

    saveContinuousPlaySessionData(objMediaTrackingMetadata) {
        let storage = JSON.parse(localStorage.getItem('cbs_cp')) || {}
        storage.cp = {}

        Object.keys(objMediaTrackingMetadata).forEach((key) => {
            storage.cp[key] = objMediaTrackingMetadata[key]
        })

        localStorage.setItem('cbs_cp', JSON.stringify(storage))
        document.cookie = 'CBS_CP=1;path=/'
    }

    /**
     * Function called by smartTag to get ad blocker status
     * @return {Boolean} true if ad blocker is installed, false if not installed
     */
    pollABState() {
        if (window._sp_ === undefined || CBS.Registry.user.sb.indexOf('sb|14') !== -1) {
            return false;
        } else {
            window._sp_.rerunDetection(); //reruns the detection
            window._sp_.isAdBlocking((isBlocking) => {
                this.hasAdBlocker = isBlocking;
            });

            return this.hasAdBlocker;
        }
    }

    /**
     * Function called when the smartTag and plugin is ready
     * @return {void}
     */
    activateSkinSideBar() {
        //Find a better way to do this.
        window.SmartTag.list[0].API.SKIN.pageAction({ action: 'PageAction.LIVE_MENU_CLICK' });
    }

    getVideoAdSessionValues = async () => {
        let videoAdSessionValues = {
            _fw_continuous_play: this.__cpsession || '0',
            cpPre: '0',
            cpSession: this.__cpsession || '0',
            csid: '',
            device_region_language: 'en',
            esb: '',
            ftag: '',
            ge: '',
            gr: '',
            gpp: '', 
            gpp_sid: '',
            host: '',
            partner: '',
            ppid: '',
            ptype: '',
            region: 'us',
            sb: '',
            session: '',
            ssb: '',
            subses: '',
            sub: '',
            tfcd: '',
            tsb: '',
            vguid: '',
            vid: ''
        };

        if (this.fch) {
            videoAdSessionValues.section = 'free-content-hub';
        }
        let cbsAdvVal = jQuery.cookie('CBS_ADV_VAL');
        let cbsAdvSubsesVal = jQuery.cookie('CBS_ADV_SUBSES_VAL');

        if (cbsAdvVal != null && cbsAdvVal != '') videoAdSessionValues.session = cbsAdvVal;
        if (cbsAdvSubsesVal != null && cbsAdvSubsesVal != '')
            videoAdSessionValues.subses = cbsAdvSubsesVal;

        let cbs_u = jQuery.cookie('CBS_U');
        if (cbs_u != null) {
            cbs_u = cbs_u.replace(/"/g, '');
            let result = {};
            cbs_u.split('|').forEach(function (x) {
                let arr = x.split(':');
                arr[1] && (result[arr[0]] = arr[1]);
            });
            if (result.ge != 'null' && result.ge != '') videoAdSessionValues.ge = result.ge;
            if (result.gr != 'null' && result.gr != '') videoAdSessionValues.gr = result.gr;
        }

        let ftag = window.location.getParam('ftag');
        if (!ftag && window.location.hash) {
            if (location.hash.split('ftag=') != '') {
                ftag = window.location.hash.split('ftag=')[1].split('&')[0];
                videoAdSessionValues.ftag = ftag;
            }
        }

        videoAdSessionValues.ppid =
            this.smartTagParams && this.smartTagParams.ppid ? this.smartTagParams.ppid : '';

        let profileType = CBS.Registry.user.profile_type || '';
        videoAdSessionValues.tfcd =
            profileType === 'KIDS' ||
            profileType === 'YOUNGER_KIDS' ||
            (this.smartTagParams.adCallParams &&
                this.smartTagParams.adCallParams.standardParams &&
                this.smartTagParams.adCallParams.standardParams.tfcd)
                ? 1
                : 0;
        videoAdSessionValues.csid = this.smartTagParams.csid
            ? this.smartTagParams.csid
            : `vcbs_cbs_${CBS.Registry.platform.isMobile ? 'mobile' : 'desktop'}_web_${this.smartTagParams.isLive ? 'live' : 'vod'}`;
        videoAdSessionValues.vguid = window.__page_uuid ? __page_uuid : '';
        videoAdSessionValues.cpPre =
            this.smartTagParams &&
            this.smartTagParams.cpPre &&
            this.smartTagParams.cpPre === true &&
            this.__cpPre === true
                ? '1'
                : '0';
        videoAdSessionValues.gpp = CBS.Registry.gpp.gppString || '';
        videoAdSessionValues.gpp_sid = CBS.Registry.gpp.gppSid || '';
        videoAdSessionValues.sub =
            this.smartTagParams && this.smartTagParams.gusr ? this.smartTagParams.gusr : '';
        videoAdSessionValues.vid =
            this.smartTagParams && this.smartTagParams._contentID
                ? this.smartTagParams._contentID
                : '';
        videoAdSessionValues.partner =
            this.smartTagParams && this.smartTagParams.partner ? this.smartTagParams.partner : '';
        videoAdSessionValues.host = CBS.Registry.host ? CBS.Registry.host : '';
        videoAdSessionValues.ptype =
            window.utag_data && window.utag_data.pageType ? window.utag_data.pageType : '';

        let userStatus = this.smartTagParams.userStatus;
        if (userStatus) {
            userStatus.split(',').forEach(function (x) {
                let arr = x.split('|');
                if (arr[1]) {
                    videoAdSessionValues[arr[0]] = arr[1];
                }
            });
        }

        return videoAdSessionValues;
    };

    updateChromecastParams(listing, paramsVO) {
        if (!Helper.getCoords()) {
            const geoLocation = JSON.parse(localStorage.getItem('storageLocation'));
            console.log('Attempting to use location', geoLocation);
            if (geoLocation) {
                Helper.setLocation(localStorage);
            } else {
                console.warn(
                    'Could not to set location details: resources requiring location might fail to load'
                );
            }
        }
        const registry = Helper.getRegistry();
        if (!registry || !this.smartTagVO.params) return;
        registry.paramsVO.setByPage.streamType = paramsVO.CONTEXT.metadata.stationCode
            ? null
            : 'etl';
        Helper.setRegistry(registry);
        paramsVO.CONTENT.stationName =
            listing.streamType === 'syncbak' ? paramsVO.CONTEXT.metadata.stationCode : null;
        Helper.updateTagVOProp('params', {
            ...this.smartTagVO.params,
            ...{
                CONTENT: { ...this.smartTagVO.params.CONTENT, ...paramsVO.CONTENT }
            }
        });
    }

    getbrandLogoUrl() {
        var slug = this.apiMetadata[0].brandSlug ?? null;
        //if brand slug is undefined
        if (!slug) {
            return;
        }
        var brandLogoKey = `Brand-${slug}`;
        var logoFetchUrl = `${CBS.Registry.region.prefix}/video/getbrand/${slug}/brand.json`;
        return new Promise((resolve, reject) => {
            if (localStorage.getItem(brandLogoKey)) {
                this.brandLogoUrl = localStorage.getItem(brandLogoKey);
                resolve();
                return;
            }
            return fetch(logoFetchUrl)
                .then((response) => {
                    return response ? response.json() : false;
                }).then((json) => {
                    if (json) {
                        let brand = json.brand;
                        this.brandLogoUrl = brand.isPlayerAttributionVisible && brand.filepathLogoRegularWeb ? brand.filepathLogoRegularWeb : '';
                        localStorage.setItem(brandLogoKey, this.brandLogoUrl)
                    } else {
                        localStorage.setItem(brandLogoKey, '');
                        this.brandLogoUrl = false;
                    }
                    resolve();

                })
                .catch((error) => {
                    console.log(error);
                    reject(error)
                });
        })
    }
}
